import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as mainActions from "../../actions/mainActions";
import {
    Grid,
    Card,
    Typography,
    LinearProgress,
    Button,
    Icon
} from "material-ui";
import AddIcon from "@material-ui/icons/Add";
import { requestSurveys } from "../../controllers/surveys";
import PaginatedTable from "../displayComponents/PaginatedTable";
import { toast } from "react-toastify";
import moment from "moment";
import {
    formatSurveys, getFilterText, setHeader, setFooter
} from "../../utils/utils";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import DatePickerCustom from "../displayComponents/DatePickerCustom";
import icon_pdf from "../../resources/images/icon_pdf.png";
import SelectComponent from "../displayComponents/SelectComponent";
import { validateDatesFilter } from "../SurveyResults/SurveyResultsContainer";
import ShortSurvey from './ShortSurvey';
import Survey from './Survey';

class Surveys extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: 'Listado de enquisas',
            currentPage: 0,
            currentLimit: 15,
            downloading: false,
            surveyList: [],
            rows: 0,
            loading: true,
            columns: [
                {
                    name: "id",
                    title: "Num. Cons."
                },
                {
                    name: "survey_date",
                    title: "Data da enquisa"
                },
                {
                    name: "consult_type",
                    title: "Tipo Cons."
                },
                {
                    name: "group_number",
                    title: "Num. pax."
                },
                {
                    name: "procedencia",
                    title: "Procedencia"
                },
                {
                    name: "duration",
                    title: "Duración"
                },
                {
                    name: "overnight_accommodation",
                    title: "Aloxamento"
                },
                {
                    name: "municipality_name",
                    title: "Concello"
                },
                {
                    name: "office_name",
                    title: "Oficina"
                },
                // {
                //     name: "user_name",
                //     title: "Usuario"
                // },
                {
                    name: "source",
                    title: "Orixe"
                }
            ],
            filter: {
                municipality: -1,
                office: -1,
                user: "-1",
                from: moment()
                    .subtract(3, "month")
                    .format("DD/MM/YYYY 00:00"),
                to: moment().format("DD/MM/YYYY 23:59")
            },
            showShortSurvey: false,
            showSurvey: false,
            surveyId: 0,
        };
    }

    updateFilter = (value, name) => {
        if (
            !validateDatesFilter(this.state.filter.from, this.state.filter.to, {
                value: value,
                name: name
            })
        ) {
            toast("A data elexida no é válida", {
                className: "toast-error",
                autoClose: 2000
            });
        } else {
            let filter = {};
            filter[name] = value;
            if (name === 'municipality') filter.office = -1;
            const { defaultLimit } = this.props.main;
            this.setState({ filter: { ...this.state.filter, ...filter }, currentPage: 0 }, () => {
                this.loadData(
                    0,
                    defaultLimit
                );
            });
        }
    };

    exportPdf = async () => {
        const HEIGHT = 170;
        this.setState({ downloading: true });
        try {
            const { filter, title } = this.state;            
            const { columns } = this.state;
            const { consultTypes, countries, provinces, offices, municipalities, sessionData } = this.props.main;
            const NUM_ROWS = 35;
            let response = await requestSurveys(
                sessionData.userName,
                sessionData.passwd,
                {
                    type: "survey",
                    filter: this.state.filter
                }
            );
            let excelSurveys = formatSurveys(response.result.data, consultTypes, countries, provinces);
            let doc = new jsPDF({
                orientation: "portrait",
                unit: "mm",
                format: "a4"
            });
            for (
                let i = 0;
                i < Math.ceil(excelSurveys.length / NUM_ROWS);
                i++
            ) {
                if (i !== 0) doc.addPage();
                let filter_text = getFilterText(filter, municipalities, offices);
                setHeader(doc, title, `Período: ${filter.from} a ${filter.to} ${filter_text}`);
                setFooter(doc, i + 1, Math.ceil(excelSurveys.length / NUM_ROWS));

                let table = document.createElement("table");
                table.setAttribute("id", "table-excel_" + i);
                table.setAttribute(
                    "style",
                    "width: 1320px; text-align: center; position: absolute; right: 10000px"
                );
                let tbody = document.createElement("tbody");
                //HEADER
                let headerRow = document.createElement("tr");
                headerRow.setAttribute(
                    "style",
                    "height: 45px; border-bottom: 1px solid #ddd;"
                );
                columns.map(column => {
                    let cell = document.createElement("th");
                    cell.innerText = column.title;
                    headerRow.appendChild(cell);
                });
                tbody.appendChild(headerRow);
                //BODY
                for (let j = i * NUM_ROWS; j < (i + 1) * NUM_ROWS; j++) {
                    let survey = excelSurveys[j];
                    if (survey) {
                        let tableRow = document.createElement("tr");
                        tableRow.setAttribute(
                            "style",
                            "height: 45px; border-bottom: 1px solid #ddd;"
                        );
                        columns.map(column => {
                            let tableCell = document.createElement("td");
                            tableCell.innerText = survey[column.name];
                            tableRow.appendChild(tableCell);
                        });
                        tbody.appendChild(tableRow);
                    }
                }
                table.appendChild(tbody);
                document.body.appendChild(table);
                let element = document.getElementById("table-excel_" + i);
                let canvas = await html2canvas(
                    element
                );
                let widthCanvas = canvas.getAttribute('width');
                let heightCanvas = canvas.getAttribute('height');
                let height = 200 * heightCanvas / widthCanvas
                doc.addImage(canvas, 5, 30, 200, height);
                setTimeout(()=> element.parentNode.removeChild(element), 250);
            }
            doc.save("listado");
            this.setState({ downloading: false });

        } catch (err) {
            this.setState({ downloading: false });
            console.error(err);
            toast(
                "Produciuse un erro cargando os datos, intenteo de novo máis tarde",
                { autoClose: 4000, className: "toast-error" }
            );
        }
    };

    componentDidMount() {
        const { currentPage } = this.state;
        const { defaultLimit, sessionData } = this.props.main;
        if (sessionData.municipality){
            this.setState({ filter: { ...this.state.filter,  municipality: sessionData.municipality} }, async ()=>{
                this.loadData(currentPage * defaultLimit, defaultLimit);
            })
        } else{
            this.loadData(currentPage * defaultLimit, defaultLimit);
        }
    }

    refresh = () => {
        const { currentPage, currentLimit } = this.state;
        this.loadData(currentPage * currentLimit, currentLimit);
    }

    loadData = async (start, limit, page) => {
        try {
            const { sessionData } = this.props.main;
            const { currentPage, currentLimit } = this.state;
            if (page !== undefined && page !== currentPage)
                this.setState({ currentPage: page });
            if (limit !== undefined && limit !== currentLimit)
                this.setState({ currentLimit: limit });
            let currentFilter = this.state.filter;
            let params = {
                type: "survey",
                start: start,
                limit: limit,
                filter: currentFilter
            };
            let response = await requestSurveys(
                sessionData.userName,
                sessionData.passwd,
                params
            );
            this.setState({
                surveyList: response.result.data,
                loading: false,
                rows: response.result.total,
            });
        } catch (err) {
            this.setState({ loading: false });
            console.error(err);
            toast(
                "Produciuse un erro cargando os datos, intenteo de novo máis tarde",
                { autoClose: 4000, className: "toast-error" }
            );
        }
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.loading === true) {
            return { loading: false };
        }
        return null;
    }

    closeDetail = () => {
        this.setState({
            showShortSurvey: false,
            showSurvey: false,
            surveyId: 0
        });
    }

    newShortSurvey = () => {
        this.setState({
            showShortSurvey: true,
            showSurvey: false,
            surveyId: 'new'
        });
    }

    newSurvey = () => {
        this.setState({
            showShortSurvey: false,
            showSurvey: true,
            surveyId: 'new'
        });
    }

    openSurvey = survey => {
        if (survey.enquisa_abreviada === 1) {
            this.setState({
                showShortSurvey: true,
                showSurvey: false,
                surveyId: survey.id
            });
        } else {
            this.setState({
                showShortSurvey: false,
                showSurvey: true,
                surveyId: survey.id
            });
        }
    };

    render() {
        const {
            downloading,
            columns,
            loading,
            surveyList,
            rows,
            filter: { from, to, office, municipality },
            showShortSurvey,
            showSurvey,
            surveyId,
            currentPage,
            currentLimit
        } = this.state;
        const { municipalities, offices, sessionData } = this.props.main;

        if (showShortSurvey) {
            return (
                <ShortSurvey id={surveyId} refresh={this.refresh} close={this.closeDetail} />
            )
        }

        if (showSurvey) {
            return (
                <Survey id={surveyId} refresh={this.refresh} close={this.closeDetail} />
            )
        }

        return (
            <Fragment>
                <Grid item xs={12}>
                    <Card elevation={0} style={{ padding: "0.5em 1em" }}>
                        <Grid container spacing={16}>
                            <Grid item xs={4}>
                                <div style={{ flexDirection: "column" }}>
                                    <DatePickerCustom
                                        label="Dende"
                                        value={from}
                                        format="DD/MM/YYYY"
                                        displayFormat="LL"
                                        setDate={moment => {
                                            this.updateFilter(moment.format("DD/MM/YYYY HH:mm"), "from");
                                        }}
                                    />
                                    <DatePickerCustom
                                        label="Ata"
                                        value={to}
                                        format="DD/MM/YYYY"
                                        displayFormat="LL"
                                        setDate={moment => {
                                            this.updateFilter(moment.format("DD/MM/YYYY HH:mm"), "to");
                                        }}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={4}>
                                <SelectComponent
                                    disabled={!!sessionData.municipality}
                                    label="Concello"
                                    defaultValue="Todos"
                                    items={municipalities}
                                    value={municipality}
                                    fieldValue="id"
                                    fieldName="name"
                                    setValue={event => {
                                        this.updateFilter(event.target.value, "municipality");
                                    }}
                                />
                                <SelectComponent
                                    label="Oficina"
                                    defaultValue="Todas"
                                    items={
                                        !!municipality && municipality != -1
                                            ? offices.filter(office => {
                                                return office.municipality_id === municipality;
                                            })
                                            : offices
                                    }
                                    value={office}
                                    fieldValue="id"
                                    fieldName="name"
                                    setValue={event => {
                                        this.updateFilter(event.target.value, "office");
                                    }}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <div style={{ display: 'inline-block', marginRight: '-1em' }}>
                                    <Button variant="raised" color="secondary" 
                                        style={{ 
                                            marginTop: '0.5em',
                                            float: 'right',
                                            marginRight: '1em'
                                        }}
                                        onClick={this.newSurvey}><AddIcon />Engadir enquisa completa </Button>
                                    <Button variant="raised" color="secondary" style={{
                                        marginTop: '0.5em',
                                        float: 'right',
                                        marginRight: '1em'
                                    }} onClick={this.newShortSurvey}><AddIcon />Engadir enquisa abreviada </Button>
                                    <Button disabled={downloading} style={{
                                        backgroundColor: "#DDD",
                                        marginTop: '0.5em',
                                        float: 'right',
                                        marginRight: '1em'
                                    }} onClick={this.exportPdf}>
                                        Exportar listado a pdf
                                            <Icon style={{
                                            marginLeft: "0.8rem",
                                            color: "#f53838"
                                        }}>
                                            <img src={icon_pdf} alt="Exportar como pdf" />
                                        </Icon>
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                    </Card>
                </Grid>
                {loading ? (
                    <Card style={{ width: '100%' }} elevation={0}>
                        <Typography variant="headline" component="h4">Cargando enquisas...{" "}</Typography>
                        <LinearProgress />
                    </Card>
                ): downloading ? (
                    <Card style={{ width: '100%' }} elevation={0}>
                        <Typography variant="headline" component="h4">Exportando enquisas...{" "}</Typography>
                        <LinearProgress />
                    </Card>
                ) : (
                        <PaginatedTable
                            openSurvey={this.openSurvey}
                            updateItems={this.loadData}
                            itemList={surveyList}
                            rows={rows}
                            columns={columns}
                            noResultsText="Non se atoparon enquisas"
                            datefilter={true}
                            defaultPage={currentPage}
                            defaultLimit={currentLimit}
                        />
                    )}
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    main: state.main
});

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(mainActions, dispatch)
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Surveys);



// WEBPACK FOOTER //
// ./src/components/Surveys/Surveys.js